<template>
  <div class="product_layout p-t-0">
    <el-row class="m-t-40 p-b-50" type="flex" justify="center" :span="24">
      <el-col :xs="14" :sm="15" :md="15" :lg="17" :xl="17">
        <span class="product_title">Та <span :style="'color:'+this.textColor()">өөрт </span>хэрэгтэй бараагаа олоорой.</span>
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
        <router-link class="cursor menu_text desktop_menu" to="/products">
          <el-button class="flr product_detail_button" :style="'background-color:' + bgColor()" icon="el-icon-caret-right"></el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row class="p-b-100" type="flex" justify="center">
      <el-col :span="19" >
        <el-tabs  v-model="activeTab" tab-position="top"  @tab-click="getCategoryByProduct()">
          <el-tab-pane v-for="(item, index) in this.categoriesGetter" :key="index" :name="item.category_name">
            <span slot="label" >
              <el-tag class="black_tag" >8</el-tag> {{ item.category_name }}
            </span>
            <el-row class="product_tab_pane m-l-40" :gutter="20" v-loading="productLoading">
              <div v-if="products.length > 0">
                <ProductByCategory :productsProp=products></ProductByCategory>
              </div>
              <div v-else>
                хоосон
              </div>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>

</template>
<script>
import CategoryOne from '@/assets/category_1.png'
import ProductByCategory from './productByCategory.vue'
import services from '@/helpers/services.js'
import {
  mapGetters
} from 'vuex'
export default {
  name: 'CategoryComponent',
  computed: mapGetters({
    categoriesGetter: 'categoriesGetter'
  }),
  components: {
    ProductByCategory
  },
  data: function () {
    return {
      CategoryOne: CategoryOne,
      tabPosition: 'top',
      windowWidth: window.innerWidth,
      // activeName: '',
      productLoading: false,
      activeTab: 'Фитнес хэрэгсэл',
      products: [
      ]
    }
  },
  created () {
    this.calculateWindow()
    this.getCategoryByProduct()
    this.getCategories()
  },
  methods: {
    getCategories () {
      const localCategories = window.localStorage.getItem('categories')
      if (localCategories) {
        this.categories = JSON.parse(localCategories)
      } else {
        const payload = {
          company_id: '11',
          category_id: null

        }
        services.getCategories(payload)
          .then((response) => {
            if (response.status === 'success') {
              this.$store.dispatch('addCategories', response.result)
            }
          })
      }
    },
    getCategoryByProduct () {
      this.productLoading = true
      const payload = {
        category_id: null,
        company_id: 11
      }
      this.categoriesGetter.forEach(element => {
        console.log(element.category_name, this.activeTab, 'sda')
        if (element.category_name === this.activeTab) {
          payload.category_id = element.id
          payload.company_id = 11
        }
        // endees irsen buteegdehuunuudiig this.products hjiigeerei
      })
      services.getProductByCategory(payload)
        .then((response) => {
          response.result.forEach(element => {
            element.item_count = 1
          })
          this.products = response.result
          console.log(this.products)

          this.productLoading = false
          // this.$root.fullscreenLoading = false
        })
    },
    calculateWindow () {
      this.tabPosition = (this.windowWidth > 900) ? 'left' : 'top'
    },
    textColor () {
      if (window.location.hostname === 'iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    },
    bgColor () {
      if (window.location.hostname === 'www.iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    }
  }
}

</script>

<style>
.product_title_color{
        color: #5E1EE5;
    }
</style>
